module.exports = __webpack_public_path__ + "img/odt-white.111a8cc8.svg";